module.exports = __webpack_public_path__ + "media/images/kumu-step2-caec374d81ccbbc8075f0529b7d5d3f8.png";